/* eslint-disable */
/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config file > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/



import {Notify,Dialog,Loading} from 'quasar'



export default { config: {"dark":false,"brand":{"primary":"#2e7fb5","secondary":"#1b8fa0","accent":"#1a4a6b","dark":"#0d2b45","dark-page":"#e8f4f8","positive":"#1b8fa0","negative":"#e05a3a","info":"#2e7fb5","warning":"#e8a020"},"capacitor":{"iosStatusBarPadding":true,"backButtonExit":false}},plugins: {Notify,Dialog,Loading} }

